import { msg } from '@lingui/core/macro';

import { defineFilters } from '@/shared/filters/define-filters';
import { stripDocumentSeparators } from '@/shared/format/internal';

import { OPERATOR_STATUS_OPTIONS } from './bank-account-tabs.filters';

// Filtros da aba Favorecidos (P01). Leve: entra no `validateSearch` da rota do detalhe.
//
// O fio usa `searchString` e `f_status`, como Operadores, e as duas abas dividem a URL do detalhe: aqui a
// chave da URL é própria da aba (`fav_*`) e o `param` devolve o nome do fio.

/**
 * `availableFilters` da aba (`FavoredTabContainer.tsx:291-303`), na ordem do "Filtrar por". O Status tem as
 * mesmas 8 opções de Operadores (`statusBankAccountOptions`, `constants.ts:12-21`). O CPF/CNPJ vai sem
 * separadores e com as letras do CNPJ alfanumérico (⚠️: o legado só limpava o campo, `cleanDocumentValue`).
 */
export const beneficiaryListFilters = defineFilters([
  { key: 'fav_searchString', param: 'searchString', type: 'search', label: msg`Todos`, placeholder: msg`Filtrar por todos` },
  { key: 'fav_name', param: 'f_name', type: 'text', label: msg`Nome`, placeholder: msg`Filtrar por nome` },
  { key: 'fav_registrationNumber', param: 'f_registrationNumber', type: 'document', label: msg`CPF/CNPJ`, placeholder: msg`Filtrar por CPF/CNPJ`, toParam: stripDocumentSeparators },
  { key: 'fav_status', param: 'f_status', type: 'select', label: msg`Status`, options: OPERATOR_STATUS_OPTIONS },
]);
